import axios from 'axios'
import VueAxios from 'vue-axios'
import $store from "@store"
import router from '@router'
import JSONbig from 'json-bigint'
// import store from "store";

const serverList = [
    { name: '开发环境', url: 'dev' },
    // { name: "预发布环境", url: "test" },
    // { name: "审核环境", url: "audit" },
    // { name: "QA测试环境", url: "qaliling" },
]

const request = axios.create({
    baseURL: [
        process.env.VUE_APP_API_BASE_URL,
        'dev',
        // serverList[parseInt(store.get("SERVER") || 0)]?.url,
    ].filter((a) => !!a).join('/'),
    timeout: 300000,

    // transformRequest: [function transformRequest(data, headers) {
    //     normalizeHeaderName(headers, 'Accept');
    //     normalizeHeaderName(headers, 'Content-Type');
    //     if (utils.isFormData(data) ||
    //         utils.isArrayBuffer(data) ||
    //         utils.isBuffer(data) ||
    //         utils.isStream(data) ||
    //         utils.isFile(data) ||
    //         utils.isBlob(data)
    //     ) {
    //         return data;
    //     }
    //     if (utils.isArrayBufferView(data)) {
    //         return data.buffer;
    //     }
    //     if (utils.isURLSearchParams(data)) {
    //         setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
    //         return data.toString();
    //     }
    //     if (utils.isObject(data)) {
    //         setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
    //         return JSON.stringify(data);
    //     }
    //     return data;
    // }],
    transformResponse: [
        function transformResponse(data) {
            // console.log(data)
            /*eslint no-param-reassign:0*/
            if (typeof data === 'string') {
                try {
                    data = JSONbig.parse(data)
                } catch (e) {
                    /* Ignore */
                }
            }
            return data
        },
    ],
})

const errorHandler = (error) => {
    return Promise.reject(error)
}

request.interceptors.request.use((config) => {
    config.headers["token"] = $store?.state?.user?.token
    return config
}, errorHandler)

request.interceptors.response.use((response) => {
    switch (response?.data?.code) {
        case 0:
            return response.data
        case 10001:
            router.push({ name: 'login' })
            throw new Error(response?.data?.message)
        default:
            throw response?.data || { code: -1, message: '请求无返回' }
    }
}, errorHandler)

const install = function (app) {
    app.use(VueAxios, request)
}

request.install = function (app) {
    app.use(VueAxios, request)
}

const defaultPost = function (dir) {
    return (data) => {
        return request(dir.toLowerCase(), {
            method: 'POST',
            data: data,
        })
    }
}

export default request
export { install, serverList, defaultPost }
